import React, { ReactElement } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import ActivityGroup from '../../components/ActivityGroup';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: theme.spacing(4),
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
      gridTemplateRows: '1fr',
      gap: '0 16px'
    },
    cardHeaderContainer: {
      background: theme.palette.secondary.main
    }
  };
});

type WeekCardsListProps = {
  data: any;
};

const WeekCardsList: React.FC<WeekCardsListProps> = ({ data }) => {
  const classes = useStyles();

  const renderCards = (data: any): Array<React.ReactElement> => {
    return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'].map((day, index) => (
      <ActivityGroup
        key={`${day}_${index}`}
        title={day}
        activities={data?.[day]}
        subtitleGenerator={({ week, asn }) => `Week ${week}, Activity ${asn}`}
        nameGenerator={({ name }) => `${name}`}
      />
    ));
  };

  return <div className={classes.container}>{renderCards(data)}</div>;
};

export default WeekCardsList;
